if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');
			this.thumbsHolder = this.querySelector('.product-gallery__thumbnails-holder');
			this.variantGalleryMap = this.parseVariantGalleryMap();
			this._gallerySelectingVariant = false;

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			this.bindGalleryThumbnails();

			if ( this.productSlider ) {

				this.productSlider.addEventListener('change', e=>{
					this.thumbnailNavigationHelper(e.target.index);
					this.scrollActiveThumbnailIntoView(e.target.index);
					const activeItem = this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`);
					if ( activeItem && activeItem.dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', activeItem.dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				this.productSlider.addEventListener('ready', ()=>{
					if ( this.firstProductGalleryIndex != null ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {

				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						if ( inputParent.classList.contains('product-variant__item--color' ) ) {
							inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
						}
					})
				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
							if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

		}

		parseVariantGalleryMap(){
			const mapEl = this.querySelector('[data-js-variant-gallery-map]');
			if ( ! mapEl ) return [];
			try {
				const parsed = JSON.parse(mapEl.textContent);
				return Array.isArray(parsed) ? parsed : [];
			} catch (err) {
				return [];
			}
		}

		bindGalleryThumbnails(){
			const thumbs = this.querySelectorAll('.product-gallery__thumbnails .thumbnail');
			if ( ! thumbs.length ) return;

			thumbs.forEach((elm)=>{
				elm.addEventListener('click', (e)=>{
					const button = e.currentTarget;
					const index = button.dataset.index;
					this.goToGalleryIndex(index);

					if ( this.thumbsHolder ) {
						this.thumbsHolder.scrollTo({
							top: button.offsetTop - 40,
							left: button.offsetLeft - 40,
							behavior: 'smooth'
						});
					}

					if ( this.productGallery && this.productGallery.hasAttribute('data-nj-thumbs-gallery') ) {
						this.selectVariantFromMedia(button.dataset.mediaId);
					}
				});
			});
		}

		goToGalleryIndex(index){
			if ( index == null || index === '' ) return;
			index = parseInt(index, 10);
			if ( Number.isNaN(index) ) return;

			this.thumbnailNavigationHelper(index);

			if ( this.productSlider && this.productSlider.sliderEnabled ) {
				if ( this.productSlider.index != index ) {
					this.productSlider.changeSlide(index);
				}
			} else if ( this.productSlider ) {
				this.firstProductGalleryIndex = index;
			} else if ( this.productGallery ) {
				const item = this.productGallery.querySelector(`.product-gallery-item[data-index="${index}"]`);
				if ( item ) {
					item.scrollIntoView({behavior: 'smooth', block: 'center'});
				}
			}
		}

		scrollActiveThumbnailIntoView(index){
			if ( ! this.thumbsHolder ) return;
			const thumb = this.querySelector(`.product-gallery__thumbnails .thumbnail[data-index="${index}"]`);
			if ( ! thumb ) return;
			const holderRect = this.thumbsHolder.getBoundingClientRect();
			const thumbRect = thumb.getBoundingClientRect();
			if ( thumbRect.top < holderRect.top || thumbRect.bottom > holderRect.bottom || thumbRect.left < holderRect.left || thumbRect.right > holderRect.right ) {
				this.thumbsHolder.scrollTo({
					top: thumb.offsetTop - 40,
					left: thumb.offsetLeft - 40,
					behavior: 'smooth'
				});
			}
		}

		selectVariantFromMedia(mediaId){
			if ( ! mediaId || ! this.productVariants || this._gallerySelectingVariant ) return;

			const matches = this.variantGalleryMap.filter(item => String(item.media_id) === String(mediaId));
			if ( ! matches.length ) return;

			const currentId = this.productVariants.currentVariant && this.productVariants.currentVariant.id;
			if ( currentId && matches.some(item => String(item.variant_id) === String(currentId)) ) return;

			this.selectVariantByMap(matches[0]);
		}

		selectVariantByMap(match){
			if ( ! match || ! match.options || ! this.productVariants ) return;

			const containers = this.productVariants.querySelectorAll('[data-js-product-variant-container]');
			if ( ! containers.length ) return;

			this._gallerySelectingVariant = true;

			match.options.forEach((opt, i)=>{
				const container = containers[i];
				if ( ! container ) return;

			const escaped = (window.CSS && typeof CSS.escape === 'function') ? CSS.escape(String(opt)) : String(opt).replace(/"/g, '\\"');
			const input = container.querySelector(`input[value="${escaped}"]`);
			const option = container.querySelector(`option[value="${escaped}"]`);
				const isLast = i === match.options.length - 1;

				if ( input && ! input.checked ) {
					input.checked = true;
					if ( isLast ) {
						input.dispatchEvent(new Event('change', { bubbles: true }));
					}
				} else if ( option && ! option.selected ) {
					option.selected = true;
					if ( isLast ) {
						container.dispatchEvent(new Event('change', { bubbles: true }));
					}
				} else if ( isLast && ( (input && input.checked) || (option && option.selected) ) ) {
					const target = input || container;
					target.dispatchEvent(new Event('change', { bubbles: true }));
				}
			});

			requestAnimationFrame(()=>{
				this._gallerySelectingVariant = false;
			});
		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm)=>{
				const isActive = parseInt(elm.dataset.index, 10) == index;
				elm.classList.toggle('active', isActive);
				elm.setAttribute('aria-pressed', isActive ? 'true' : 'false');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				if ( variant.featured_media != null && this.productGallery ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.goToGalleryIndex(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
								this.thumbnailNavigationHelper(variantImg.dataset.index);
								this.scrollActiveThumbnailIntoView(variantImg.dataset.index);
							}
						} else {
							this.thumbnailNavigationHelper(variantImg.dataset.index);
							this.scrollActiveThumbnailIntoView(variantImg.dataset.index);
							if ( variantImg.getBoundingClientRect().top > window.innerHeight ) {		
								variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
							} else if ( variantImg.getBoundingClientRect().top < 0 ) {
								variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
							}
						}
					}
				}
				
				this.querySelectorAll('.product-variant__item--color [data-selected]').forEach(elm=>{
					elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
				});

			}

		}
		
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}
